/**
 * Recursively removes empty fields, null values, empty arrays, and empty objects from an object
 * @param {Object} obj - The object to clean
 * @returns {Object} - The cleaned object
 */
export const cleanEmptyFields = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  
  // Handle arrays
  if (Array.isArray(obj)) {
    const filteredArr = obj
      .map(item => cleanEmptyFields(item))
      .filter(item => {
        if (item === null || item === undefined) return false;
        if (typeof item === 'object' && Object.keys(item).length === 0) return false;
        if (Array.isArray(item) && item.length === 0) return false;
        return true;
      });
    return filteredArr.length ? filteredArr : undefined;
  }
  
  // Handle objects
  const result = {};
  for (const key in obj) {
    const value = cleanEmptyFields(obj[key]);
    
    // Special handling for segments - preserve the entire structure
    if (key === 'segments') {
      // Always preserve the segments object with its required fields
      result[key] = {
        type: obj[key]?.type || 'ALL_CUSTOMERS',
        selectedSegments: obj[key]?.selectedSegments || [],
        excludedSegments: obj[key]?.excludedSegments || {}
      };
      continue;
    }
    // Special handling for nested segment fields - preserve even if they appear empty
    if (key === 'selectedSegments') {
      result[key] = value || [];
      continue;
    }
    if (key === 'excludedSegments') {
      result[key] = value || {};
      continue;
    }
    
    // Skip null, undefined, empty strings, empty arrays, and empty objects
    if (value === null || value === undefined) continue;
    if (value === '') continue;
    if (Array.isArray(value) && value.length === 0) continue;
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) continue;
    
    result[key] = value;
  }
  
  return Object.keys(result).length ? result : undefined;
};
